import React from 'react';
import { connect } from 'react-redux';
import { MentionsInput, Mention } from 'react-mentions';
import UrlPreview from '../Utils/UrlPreview';
import agent from '../../agent';
import { FETCH_MENTION_STARTED, FETCH_MENTION_FINISHED } from '../../constants/actionTypes';
import { APP_CONFIG } from '../../appconfig'
import "../../components/Utils/SmallComments/SmallComments.css"
import {message} from "antd";
import {getLabel} from "../../language";
const apiPath = APP_CONFIG.apiPath;

message.config({top:50})

const mapStateToProps = state => ({
    mention: state.mention,
    anonymousMode: state.user.anonymousMode
});

const mapDispatchToProps = dispatch => ({
    getMentionUsers: () => {
        dispatch({ type: FETCH_MENTION_STARTED });
        agent.Mentions.get().then(res => {
            let usersFetched = [];
            if (res?.length) {
                res.map(item => {
                    usersFetched.push({
                        id: item.userName || item.id.toString(),
                        display: item.userName,
                        displayName: item.displayName,
                        avatar: `${apiPath}/user/${item.userName}/picture`
                    });
                })
            }
            dispatch({ type: FETCH_MENTION_FINISHED, payload: usersFetched });
        }, err => {
        })
    },
});
const defaultStyle = {
    control: {
        backgroundColor: "#fff",
        fontSize: 14,
        fontWeight: "normal"
    },
    highlighter: {
        overflow: "hidden"
    },
    input: {
        margin: 0,
        overflow: "auto",
        height: 30
    },
    "&multiLine": {
        control: {
            fontFamily: "monospace",
            border: "1px solid silver"
        },
        highlighter: {
            padding: 9
        },
        input: {
            padding: 9,
            minHeight: 3,
            outline: 0,
            border: 0
        }
    },
    suggestions: {
        bottom: "0",
        top: "unset",
        list: {
            backgroundColor: "white",
            border: "1px solid rgba(0,0,0,0.15)",
            fontSize: 14
        },
        item: {
            padding: "5px 15px",
            borderBottom: "1px solid rgba(0,0,0,0.15)",
            "&focused": {
                backgroundColor: "#cee4e5"
            }
        }
    }
};

export class MentionTeaxtarea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            parseUrlData: {},
            usersFetched: [],
            errorMessage:false,
        };
        this.onPaste = this.onPaste.bind(this);
        this.displayTransform = this.displayTransform.bind(this);
        this.getMentionByTerm = this.getMentionByTerm.bind(this);
        this.showErrorTextArea = this.showErrorTextArea.bind(this);
        this.getUrls = this.getUrls.bind(this);
    }

    componentDidMount() {
        this.props.getMentionUsers();
    }

    onPaste(e) {
        setTimeout(() => {
            if (this.props.parseUrlAsync) {
                const parsedUrls = this.getUrls(this.props.value);
                if (parsedUrls && parsedUrls.length > 0) {
                    this.props.parseUrlAsync(parsedUrls).then(result => {
                        this.setState({ parseUrlData: result.body });
                    });
                }
            }
        }, 200);
    }

    getUrls(body) {
        const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;

        const links = body.match(urlRegex, function (url) {
            return url;
        })

        return links;
    }


    renderMention(suggestion, search, highlightedDisplay) {
        return (<div className="suggestion">
            <div className="suggestion-avatar border-radius-10" style={{ backgroundImage: 'url(' + suggestion.avatar + ')' }}>
            </div>
            <div className="suggestion-name">
                <span>{suggestion.displayName}</span>
                <span>@{highlightedDisplay} {suggestion.location}</span>
            </div>
        </div>);
    }

    displayTransform(id, display, type) {
        return `@${id}`;
    }

    showErrorTextArea() {
        if(this.props.loggedIN || this.props.loggedIN === undefined){
            if (this.props.disabled) {
                // message.error(getLabel(274))
                this.setState({
                    errorMessage:true
                })
            }
            if (this.props.disabledMainComment) {
                // message.error(getLabel(274))
                this.setState({
                    errorMessage:true
                })
            }
        }
        }


    getMentionByTerm(q, callback) {
        if(q==='') {
            agent.Mentions.get(q).then(res => {
                let usersFetched = [];
                if (res) {
                    res.map(item => {
                        usersFetched.push({
                            id: item.userName || item.id.toString(),
                            display: item.userName,
                            displayName: item.displayName,
                            avatar: `${apiPath}/user/${item.userName}/picture`
                        });
                    })
                }
                this.setState({usersFetched: usersFetched});
                return callback(usersFetched);
            })
        }
        else {
            let data = [];
            this.state.usersFetched.map(item => {
                if(item?.id?.toLowerCase().includes(q.toLowerCase()) || item?.displayName?.toLowerCase().includes(q.toLowerCase())){
                    data.push(item);
                }
            })
            return callback(data);

        }
    }

    render() {
        return (
            <fieldset className="form-group">
                <div
                    className={(window.location.pathname.includes("/editor") || window.location.pathname.includes("/topicstances")) ? "mention-textarea" : ""}
                    onClick={this.showErrorTextArea}>
                    {/*<MentionsInput   className={this.props.placeholder === "Write a comment..." ?(this.props.placeholder === "Write a comment..."?(`${this.props.disabled?"textAreaDisable":"mentions form-control "}`):"mentions form-control ") : (this.props.placeholder === "Go ahead, spill your guts!"?(`${this.props.disabledMainComment?"textAreaDisable":"mentions form-control"}`):"mentions form-control")}*/}
                    {/*    style={this.props.fromEditor ? {height: `${(window.location.pathname !== "/editor") ? 202 : "auto"}`,background:`${this.props.anonymousMode ? "#1d1f20" : ""}`, color:`${this.props.anonymousMode ? "white" : ""}`}: {height: 70,background:`${this.props.anonymousMode ? "#1d1f20" : ""}`, color:`${this.props.anonymousMode ? "white" : ""}`}}*/}
                    {/*    onPaste={this.onPaste}*/}
                    {/*    value={this.props.value || ''}*/}
                    {/*    disabled={this.props.disabled}*/}
                    {/*    onChange={this.props.changeBody}*/}
                    {/*    maxLength={this.props.maxlength || ''}*/}
                    {/*    markup="__type__[[[__display__]]](__id__)"*/}
                    {/*    placeholder={this.props.placeholder === getLabel(461)?getLabel(461):(this.props.placeholder === getLabel(441) ? getLabel(441) :this.props.placeholder === getLabel(324) ? getLabel(324): (this.props.placeholder === getLabel(321)? getLabel(321):(this.props.placeholder === getLabel(320)? getLabel(320):(this.props.placeholder === getLabel(319)? getLabel(319):(this.props.placeholder === getLabel(318) ? getLabel(318)  : this.props.placeholder === "Write a comment..."?(this.state.errorMessage ? getLabel(276)  : (this.props.placeholder || '')):(this.state.errorMessage ? getLabel(279)  : (this.props.placeholder || '')))))))}*/}
                    {/*    displayTransform={this.displayTransform} >*/}
                    {/*    <Mention trigger="@"*/}
                    {/*        className="mentions-input-highlighted"*/}
                    {/*        data={this.getMentionByTerm}*/}
                    {/*        appendSpaceOnAdd={true}*/}
                    {/*        renderSuggestion={this.renderMention} />*/}
                    {/*</MentionsInput>*/}
                    <MentionsInput
                        className={this.props.placeholder === "Write a comment..." ? (this.props.placeholder === "Write a comment..." ? (`${this.props.disabled ? "textAreaDisable" : "mentions form-control "}`) : "mentions form-control ") : (this.props.placeholder === "Go ahead, spill your guts!" ? (`${this.props.disabledMainComment ? "textAreaDisable" : "mentions form-control"}`) : "mentions form-control")}
                        // value={this.props.value || ''}
                        // value={this.state.value}
                        // onChange={this.handleChange}
                        // style={defaultStyle && (this.props.anonymousMode && {background:"#1d1f20",color:"white"})}
                        style={ this.props.fromEditor ? {height: `${(window.location.pathname !== "/editor") ? 202 : "auto"}`,background:`${this.props.anonymousMode ? "#1d1f20" : ""}`, color:`${this.props.anonymousMode ? "white" : ""}`}: {minHeight: 70,background:`${this.props.anonymousMode ? "#1d1f20" : ""}`, color:`${this.props.anonymousMode ? "white" : ""}`}}
                        onPaste={this.onPaste}
                        value={this.props.value || ''}
                        disabled={this.props.disabled}
                        onChange={this.props.changeBody}
                        maxLength={this.props.maxlength || ''}
                        // markup="@displayName"
                        placeholder={this.props.placeholder === getLabel(461) ? getLabel(461) : (this.props.placeholder === getLabel(441) ? getLabel(441) : this.props.placeholder === getLabel(324) ? getLabel(324) : (this.props.placeholder === getLabel(321) ? getLabel(321) : (this.props.placeholder === getLabel(320) ? getLabel(320) : (this.props.placeholder === getLabel(319) ? getLabel(319) : (this.props.placeholder === getLabel(318) ? getLabel(318) : this.props.placeholder === "Write a comment..." ? (this.state.errorMessage ? getLabel(276) : (this.props.placeholder || '')) : (this.state.errorMessage ? getLabel(279) : (this.props.placeholder || '')))))))}
                        displayTransform={this.displayTransform}
                    >
                        <Mention trigger="@"
                                 className="mentions-input-highlighted"
                                 data={this.getMentionByTerm}
                                 appendSpaceOnAdd={true}
                                 renderSuggestion={this.renderMention}/>
                    </MentionsInput>
                    {this?.props?.showMaxLengthCounter &&
                    <span className="max-counter">{this.props?.chars_left}/{this.props?.max_chars}</span>
                    }

            </div>
                <UrlPreview {...this.state.parseUrlData} hideUrlPreviews={this.props.hideUrlPreviews} />
            </fieldset>

        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MentionTeaxtarea);
